// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --klein-blue: #002fa7;
    --light-blue: #e6f0ff;
    --white: #ffffff;
    --gray: #f0f0f0;
    --dark-gray: #333333;
  }
  
  body {
    font-family: Arial, sans-serif;
    background-color: var(--light-blue);
    color: var(--dark-gray);
    margin: 0;
    padding: 0;
  }
  
  .app-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .file-upload, .file-info {
    margin-bottom: 20px;
    text-align: center;
  }
  
  .upload-button {
    background-color: var(--klein-blue);
    color: var(--white);
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
  }
  
  .upload-button:hover {
    background-color: #001f6b;
  }
  
  .filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
  }
  
  select {
    padding: 8px;
    border: 1px solid var(--klein-blue);
    border-radius: 4px;
    background-color: var(--white);
    color: var(--dark-gray);
  }
  
  .data-table {
    width: 100%;
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    background-color: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid var(--gray);
  }
  
  th {
    background-color: var(--klein-blue);
    color: var(--white);
  }
  
  tr:nth-child(even) {
    background-color: var(--light-blue);
  }
  
  .total-row {
    font-weight: bold;
    background-color: var(--gray);
  }
  
  .table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
  
  .pagination {
    display: flex;
    align-items: center;
  }
  
  .pagination button {
    margin: 0 10px;
    background-color: var(--klein-blue);
    color: var(--white);
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .pagination button:hover {
    background-color: #001f6b;
  }
  
  .pagination button:disabled {
    background-color: var(--gray);
    cursor: not-allowed;
  }
  
  .pagination span {
    font-weight: bold;
  }
  
  .items-per-page {
    display: flex;
    align-items: center;
  }
  
  .items-per-page label {
    margin-right: 10px;
  }
  
  .items-per-page select {
    padding: 5px;
    border-radius: 4px;
  }
  .total-records {
    margin-left: 20px;
  }
  .loading-indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  
  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,mCAAmC;IACnC,uBAAuB;IACvB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC","sourcesContent":[":root {\n    --klein-blue: #002fa7;\n    --light-blue: #e6f0ff;\n    --white: #ffffff;\n    --gray: #f0f0f0;\n    --dark-gray: #333333;\n  }\n  \n  body {\n    font-family: Arial, sans-serif;\n    background-color: var(--light-blue);\n    color: var(--dark-gray);\n    margin: 0;\n    padding: 0;\n  }\n  \n  .app-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .file-upload, .file-info {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  \n  .upload-button {\n    background-color: var(--klein-blue);\n    color: var(--white);\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n  }\n  \n  .upload-button:hover {\n    background-color: #001f6b;\n  }\n  \n  .filters {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n  \n  select {\n    padding: 8px;\n    border: 1px solid var(--klein-blue);\n    border-radius: 4px;\n    background-color: var(--white);\n    color: var(--dark-gray);\n  }\n  \n  .data-table {\n    width: 100%;\n    overflow-x: auto;\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: var(--white);\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  th, td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid var(--gray);\n  }\n  \n  th {\n    background-color: var(--klein-blue);\n    color: var(--white);\n  }\n  \n  tr:nth-child(even) {\n    background-color: var(--light-blue);\n  }\n  \n  .total-row {\n    font-weight: bold;\n    background-color: var(--gray);\n  }\n  \n  .table-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n  }\n  \n  .pagination {\n    display: flex;\n    align-items: center;\n  }\n  \n  .pagination button {\n    margin: 0 10px;\n    background-color: var(--klein-blue);\n    color: var(--white);\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .pagination button:hover {\n    background-color: #001f6b;\n  }\n  \n  .pagination button:disabled {\n    background-color: var(--gray);\n    cursor: not-allowed;\n  }\n  \n  .pagination span {\n    font-weight: bold;\n  }\n  \n  .items-per-page {\n    display: flex;\n    align-items: center;\n  }\n  \n  .items-per-page label {\n    margin-right: 10px;\n  }\n  \n  .items-per-page select {\n    padding: 5px;\n    border-radius: 4px;\n  }\n  .total-records {\n    margin-left: 20px;\n  }\n  .loading-indicator {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n  }\n  \n  .spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
